import {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import { BiChevronDown } from 'react-icons/bi';
import { MdNotificationsActive } from 'react-icons/md';
import { toast } from 'react-toastify';
import {
  Avatar,
  Countdown,
  Messages,
  Modal,
  ViewerCustomerServiceOpen
} from '../../components';
import { useChat } from '../../contexts/chat';
import {
  getMessages,
  getMessagesOld,
  getTimeExpireSession,
} from '../../service/serviceChat/chatService';
import { maskPhone } from '../../utils';
import {
  AreaInput,
  AreaMessage,
  Container,
  Content,
  Header,
  Info,
  LoadCustomerServiceOpen,
  LoadMoreSpinerLoading
} from './styled';

export function ChatPreview(props) {

  const { idChat, customer, nameClient, parsedRender } = props;
  const { onTransferCustomerByMy, onNewCustomer, handleMyChats } = useChat()

  const [timeToExpire, setTimeToExpire] = useState(0);
  const [isSenssionExpired, setIsSenssionExpired] = useState(false);
  const [messageList, setMessageList] = useState([]);
  const [loadingMore, setLoadingMore] = useState(false);
  const [scrollBottomBtn, setScrollBottomBtn] = useState(false);
  const [notificationInChat, setNotificationInChat] = useState(false);
  const [customerServiceOpenData, setCustomerServiceOpenData] = useState(null);
  const [loading, setLoading] = useState(false);

  const refAreaMessage = useRef(null);
  const refToBottom = useRef(null);

  function reset() {
    setIsSenssionExpired(true);
  };
  const searchTimeToExpire = useCallback(async (phoneChat) => {
    const response = await getTimeExpireSession(phoneChat)
    if (response) return setTimeToExpire(response)
    return setTimeToExpire('0:00:00')
  }, []);
  const searchMessages = useCallback(async (phoneChat) => {
    return await getMessages(
      idChat,
      setMessageList,
      () => verificationOnScroll(),
    )
  }, [idChat]);
  useEffect(() => {
    reset();
    searchMessages(idChat);
  }, [idChat, searchTimeToExpire, searchMessages]);
  useEffect(() => {
    if (!isSenssionExpired) return
    if (messageList.length <= 0 || !messageList) return
    searchTimeToExpire(idChat);
  }, [messageList, idChat, searchTimeToExpire, isSenssionExpired]);

  function verificationOnScroll() {
    if (refAreaMessage.current && typeof refAreaMessage.current.scrollHeight !== 'undefined') {
      refAreaMessage.current.scrollTop = refAreaMessage.current.scrollHeight;
    } else {
      setNotificationInChat(true)
    }
  };
  function onScroll() {
    const scrollHeight = refAreaMessage.current.scrollHeight;
    const scrollTop = refAreaMessage.current.scrollTop;
    const clientHeight = refAreaMessage.current.clientHeight;
    const rest = scrollHeight - scrollTop - clientHeight;
    if (rest > 200) {
      setScrollBottomBtn(true);
    } else {
      setScrollBottomBtn(false)
    }
  };
  function handleScrollToBottom() {
    refAreaMessage.current.scrollTop = refAreaMessage.current.scrollHeight;
    if (notificationInChat) {
      setNotificationInChat(false)
    }
  };
  async function handleLoadMoreMessages() {
    setLoadingMore(true);
    await getMessagesOld(
      idChat,
      setMessageList,
      () => setLoadingMore(false),
    )
  };

  const messagesElements = useMemo(() => {
    let prevMessageDate = null;
    return messageList?.reduce((elements, message) => {
      const element = (
        <Messages
          key={message?.docMessage_id}
          message={message}
          prevMessageDate={prevMessageDate}
        />
      );
      prevMessageDate = message.date;
      return elements.concat(element);
    }, []);
  }, [messageList]);

  const handleOpenCustomer = () => {
    if (parsedRender === 5) {
      return handleNewCustomer();
    }
    return handleTransferCustomerByMy();
  }
  const msgCustomerServiceOpen = (data) => {
    return (
      <div>
        <p>
          {`Já existe atendimento em aberto ! `}
        </p>
        <u
          onClick={
            () => setCustomerServiceOpenData(data)
          }
        >
          {`ver atendimento`}
        </u>
      </div>
    )
  };
  async function handleNewCustomer() {
    setLoading(true);
    const response = await onNewCustomer(customer, true);
    if (response === 'error') {
      toast.error(
        'Error',
        {
          position: "top-center",
          theme: "colored",
        }
      );
      return setLoading(false)
    }
    if (response?.status === 'clone') {
      toast.warn(
        msgCustomerServiceOpen(response?.customerServiceOpen),
        {
          position: "top-center",
          theme: "colored",
        }
      );
      return setLoading(false)
    }
    handleMyChats();
    setLoading(false);
  }
  async function handleTransferCustomerByMy() {
    setLoading(true);
    const response = await onTransferCustomerByMy(customer, true, true);
    if (response === 'error') {
      toast.error(
        'Error',
        {
          position: "top-center",
          theme: "colored",
        }
      );
      return setLoading(false)
    }
    if (response?.status === 'clone') {
      toast.warn(
        msgCustomerServiceOpen(response?.customerServiceOpen),
        {
          position: "top-center",
          theme: "colored",
        }
      );
      return setLoading(false)
    }
    setLoading(false);
  };

  return (
    <Container>
      <Content>
        <Header>
          <Info>
            <Avatar name={nameClient} width={'3rem'} height={'3rem'} />
            <div>
              <div className="name">
                {nameClient}
                <span className='phone'>
                  {maskPhone(idChat)}
                </span>
              </div>
              <div className='countdown'>
                {timeToExpire !== 0 &&
                  <Countdown
                    initialTime={timeToExpire}
                    onChange={(e) => setIsSenssionExpired(e)}
                  />
                }
              </div>
            </div>
          </Info>
        </Header>
        <AreaMessage ref={refAreaMessage} onScroll={() => onScroll()}>
          {messageList?.length > 199 &&
            <div id='btn-loadMore'>
              {!loadingMore
                ? <button onClick={() => handleLoadMoreMessages()}>
                  {'Carregar mais'}
                </button>
                : <LoadMoreSpinerLoading />
              }
            </div>
          }
          {messagesElements}
        </AreaMessage>
        <AreaInput>
          {scrollBottomBtn &&
            <span
              ref={refToBottom}
              className='scroll--bottom'
              onClick={() => handleScrollToBottom()}
            >
              <BiChevronDown />
              {notificationInChat &&
                <MdNotificationsActive className='notification--' />
              }
            </span>
          }
          {parsedRender !== 4 &&
            <div className='content--input'>
              {loading
                ? <span className='load-span'>
                  <LoadCustomerServiceOpen />
                </span>
                : <button onClick={() => handleOpenCustomer()}>
                  Iniciar Atendimento
                </button>
              }
            </div>
          }
        </AreaInput>
      </Content>
      <Modal title={'Atendimento em aberto'}
        isOpen={customerServiceOpenData ? true : false}
        close={
          () => setCustomerServiceOpenData(null)
        }
      >
        <ViewerCustomerServiceOpen
          customerServiceOpen={customerServiceOpenData}
          onClose={
            () => setCustomerServiceOpenData(null)
          }
        />
      </Modal>
    </Container >
  );
}

